import { Loader as e } from "@systemeio/components";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/file-item/circular-progress.tsx
var n = ({ progress: n }) => /* @__PURE__ */ t(e, {
	color: "white",
	max: 100,
	size: "xl",
	value: n
});
//#endregion
export { n as CircularProgress };
